import styled from "styled-components";
import colors from "../../../../utils/colors";
import { rem } from "polished";

const Form = styled.form`
  text-align: left;
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;

  h2 {
    color: ${colors.BRAND_RED};
    text-align: left;
    font-family: FyranSans-ExtraBold;
    font-size: ${rem("15px")};
    letter-spacing: 0.18em;
    text-transform: uppercase;
    padding-bottom: 0.5rem;
  }
  /*
can't use fieldset due to flex-box restrictions / bug
	fieldset {
		width: 100%;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
*/
  footer {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    margin: 1rem 0 0;

    button {
      margin-left: 1rem;
    }
  }

  > * {
    margin-bottom: 1rem;
  }
`;

export default Form;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/Form.js